import React from "react";

import { element, object, shape, string } from "prop-types";

import { withRouter } from "react-router-dom";

import { connect } from "react-redux";

import { compose } from "../../helpers";
import { onboardUpdateState } from "../../redux/actions";

import OnboardStateItem from "../../components/OnboardStateItem/index";

import * as style from "./styles.module.scss";

const onboardStates = [
  {
    name: "basic",
    urls: ["/onboard/name"],
    content: <span>Basic information</span>,
  },
  {
    name: "address",
    urls: ["/onboard/address"],
    content: <span>Location</span>,
  },
  {
    name: "cv",
    urls: ["/onboard/cv-upload", "/onboard/work-history"],
    content: <span>CV upload</span>,
  },
  {
    name: "workType",
    urls: ["/onboard/work-type"],
    content: <span>Work type</span>,
  },
  {
    name: "personalDeclaration",
    urls: ["/onboard/personal-declaration"],
    content: <span>Declaration</span>,
  },
];

const OnboardContainer = ({ children, onboardState, location }) => {
  const checkIsActive = (name) => {
    const urlsToMatch = onboardStates.find((state) => state.name === name).urls;
    const currentUrl = location.pathname;
    return urlsToMatch.includes(currentUrl);
  };

  const getCurrentIndex = () => {
    return onboardStates.findIndex((state) =>
      state.urls.includes(location.pathname)
    );
  };

  const getProgressBarWidth = () => {
    const currentStep = getCurrentIndex() + 1;
    return `${(currentStep / onboardStates.length) * 100}%`;
  };

  return (
    <div>
      <div className="container pb-4">
        <div className="row">
          <div className="col-12">
            <ul
              className={`list-unstyled p-0 d-flex ${style.onboarding__steps}`}
            >
              {onboardStates.map(({ name, urls, content }, index) => (
                <li key={name} className={`onboardState_item`}>
                  <OnboardStateItem
                    isCompleted={onboardState[name]}
                    isActive={checkIsActive(name)}
                    url={urls[0]}
                    index={index}
                    currentIndex={getCurrentIndex()}
                  >
                    {content}
                  </OnboardStateItem>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="row mt-2 bg-white position-relative overflow-hidden">
          <div className="col-md-12">
            <div className={style.onboarding__stepContainer}>{children}</div>
          </div>
          <div
            className={style.onboarding__progressBar}
            style={{ width: getProgressBarWidth() }}
          >
            {" "}
          </div>
        </div>
      </div>
    </div>
  );
};

OnboardContainer.propTypes = {
  children: element.isRequired,
  onboardState: object.isRequired,
  location: shape({ pathname: string.isRequired }).isRequired,
};

const mapStateToProps = ({ core: { onboardState } }) => ({ onboardState });
const mapDispatchToProps = { onboardUpdateState };

const withRedux = connect(mapStateToProps, mapDispatchToProps);

const withApi = compose(withRedux, withRouter);

export default withApi(OnboardContainer);
